<template>

  <label class="flex items-start">

    <div class="leading-normal">
      <input type="checkbox" v-model="action.factorvalueids" :value="answer.action.factorvalueid" />
    </div>

    <div class="text-poly-green pl-2 leading-normal">{{ checkboxText }}</div>

  </label>

</template>

<script>
export default {

  name: 'VaFinderCheckbox',

  props: {
    answer : { type: Object, required: true },
    action : { type: Object, required: true }
  },

  computed: {

    checkboxText () {
      return this.answer.text || '';
    }
  }

}
</script>
